"use client";
import { usePathname } from "next/navigation";
import Image from "next/image";
import { useSession } from "next-auth/react";

import { LayoutWrapper } from "../LayoutWrapper/LayoutWrapper";
import styles from "./Header.module.css";
import Link from "next/link";
import { Analytics } from "@/utilities/analytics";
import { MainCategoryEnum } from "@/types/Analytics";
import { env } from "next-runtime-env";
import { onLogout } from "@/services/auth";

const style: React.CSSProperties = {
  zIndex: 2,
  position: "relative",
};

const NEXT_PUBLIC_NEXTAUTH_DOB_CLIENTID = env('NEXT_PUBLIC_NEXTAUTH_DOB_CLIENTID')

export const Header = ({
  isMenuOpened,
}: {
  isMenuOpened: boolean;
}) => {
  const currentRoute = usePathname();
  const { status, data: session } = useSession()


  const handleClick = () => {
    sessionStorage.setItem("previousRoute", window.location.href);
    let memberType = "credit_score_set";
    if (
      sessionStorage.getItem("targetScreen") === "where_is_my_report_thin_file"
    ) {
      memberType = "thin_file";
    } else if (
      sessionStorage.getItem("targetScreen") === "where_is_my_report_kba_fail"
    ) {
      memberType = "kba_file";
    }

    Analytics.logEvent("cta_get_the_app_start", {
      action: "get_the_app",
      main_category: MainCategoryEnum.DASHBOARD,
      referral_screen: "dashboard_get_the_app",
      member_type: memberType,
    });
  };

  return (
    <div
      style={style}
      className="tablet-up-hide"
      id="header"
      data-testid={"header"}
    >
      <LayoutWrapper
        isHeader={true}
        styling={{ display: "flex", justifyContent: "space-between" }}
      >
        {session?.provider === NEXT_PUBLIC_NEXTAUTH_DOB_CLIENTID ? <Image
          className="credability-logo"
          src="/logo.svg"
          alt="CredAbility Logo"
          width={108}
          height={29}
          priority={true}
          onClick={() => onLogout(session?.idToken)}
        /> :
          <Link href={"/"}>
            <Image
              src={
                currentRoute === "/" && !isMenuOpened
                  ? "/logo-white.svg"
                  : "/logo.svg"
              }
              alt="CredAbility Logo"
              width={108}
              height={29}
              priority={true}
            />
          </Link>}
        {status === "authenticated" && (
          <Link href="/app-exclusives" onClick={handleClick} data-testid="getTheApp" className={styles.getAppLink}>
            Get the app
          </Link>
        )}
      </LayoutWrapper>
    </div>
  );
};
